<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-input placeholder="请输入公司名称" v-model="formInline.search">
          </el-input>
        </el-form-item>

        <!-- <el-form-item label="所属行业分类：" prop="categorya_id" :rules="[{ required: true, message: '请选择行业分类' }]">
      <el-select v-model="formInline.categorya_id" >
        <template v-for="cat in category">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>   -->

    <el-form-item >
      <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>

       </el-form-item>



      </el-form>

      <div class="common-level-rail" style="margin-right:20px;">
            <el-upload class="avatar-uploader" ref="upload" action="string"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                   :before-upload="onBeforeUploadImage" :http-request="onimport" :show-file-list="false">
              <el-button size="small" icon="el-icon-upload"   type="primary">导入公司</el-button>
            </el-upload>
          </div>
    </div>



    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
           <el-table-column prop="company" label="企业名称">
             <template slot-scope="scope">
                <div style="overflow-y: auto;height: 100px;">
                  {{  scope.row.company}}
                </div>

              </template>
           </el-table-column>
          <el-table-column prop="op_status" label="登记状态"></el-table-column>
          <el-table-column prop="lawer" label="法定代表人"></el-table-column>
          <el-table-column prop="capital" label="注册资本"></el-table-column>
          <el-table-column prop="reg_date" label="成立日期"></el-table-column>
          <el-table-column prop="credit_code" label="统一社会信用代码"></el-table-column>
          <el-table-column prop="reg_address" label="企业注册地址">

              <template slot-scope="scope">
                <div style="overflow-y: auto;height: 100px;">
                  {{  scope.row.reg_address}}
                </div>

              </template>
          </el-table-column>
          <el-table-column prop="phone" label="电话"></el-table-column>
          <el-table-column prop="phone_more" label="更多电话"></el-table-column>
          <el-table-column prop="mail" label="邮箱"></el-table-column>
          <el-table-column prop="mail_more" label="更多邮箱"></el-table-column>
          <el-table-column prop="province" label="所属省份"></el-table-column>
          <el-table-column prop="city" label="所属城市"></el-table-column>
          <el-table-column prop="region" label="所属区县"></el-table-column>
          <el-table-column prop="tax_id" label="纳税人识别号"></el-table-column>
          <el-table-column prop="red_id" label="注册号"></el-table-column>
          <el-table-column prop="org_id" label="组织机构代码"></el-table-column>
          <el-table-column prop="Insured" label="参保人数量"></el-table-column>
          <el-table-column prop="Insured_value" label="参保人数"></el-table-column>
          <el-table-column prop="Insured_year" label="参保人数所属年报"></el-table-column>
          <el-table-column prop="org_type" label="企业(机构)类型"></el-table-column>
          <el-table-column prop="scale" label="企业规模"></el-table-column>
          <el-table-column prop="approval_date" label="核准日期"></el-table-column>
          <el-table-column prop="term" label="营业期限"></el-table-column>
          <el-table-column prop="industry" label="国标行业门类"></el-table-column>
          <el-table-column prop="category_1" label="国标行业大类"></el-table-column>
          <el-table-column prop="category_2" label="国标行业中类"></el-table-column>
          <el-table-column prop="category_3" label="国标行业小类"></el-table-column>
          <el-table-column prop="former_name" label="曾用名"></el-table-column>
          <el-table-column prop="en_name" label="英文名"></el-table-column>
          <el-table-column prop="url" label="官网网址"></el-table-column>
          <el-table-column prop="address" label="通信地址"></el-table-column>




            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>


              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :company_id="company_id"  v-if="open_edit"   @close="closeEdit"></Edit>

  </div>
</template>

<script>
import UserApi from '@/api/user.js';
  import CompanyApi from '@/api/company.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        company_id:"",
        category:[]
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      this.getCategory();
    },
    methods: {

      hasImages(e) {
        if (e) {
          return e;
        } else {
          return '';
        }
      },
          onBeforeUploadImage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase();
      const isEXCEL = (fileType === 'xlsx' || fileType === 'xls' || fileType === 'csv');
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel/csv格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isEXCEL && isLt10M;
    },

           onimport(param){
        let self = this;
        self.$confirm('是否导入公司', '提示', {
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在上传,请等待',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let formData = new FormData();
          formData.append('iFile', param.file);

          UserApi.importCompany(formData)
            .then(response => {
              loading.close();
              if(response.code == 1){
                self.getTableList();
                self.$message({
                message: response.msg,
                type: 'success'
              });
              }else{
                self.$message({
                message: response.msg,
                type: 'error'
              });
              }


            })
            .catch(response => {
              loading.close();
              self.$message({
                message: '导入失败',
                type: 'warning'
              });
            });
        });
    },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },

      /*获取行业分类*/
      getCategory() {
        // console.log(444);return
        CompanyApi.getCategory('', true)
          .then(res => {
            this.category = res.data.category;
          })
          .catch(error => {

          });
      },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        CompanyApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.company_id = row.company_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            CompanyApi.del(
              {
                company_id: row.company_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        company_id:item.company_id,
        status:1
      }
      CompanyApi.passCanel(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {


        });

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');

      var Params = {
        company_id:item.company_id,
        status:2,
        reject_val:reject_val
      }
      CompanyApi.passCanel(Params, true)
        .then(data => {
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/company/index.vue